import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import '@fontsource-variable/inter'
import '@fontsource/ibm-plex-sans-arabic/400.css'
import '@fontsource/ibm-plex-sans-arabic/500.css'
import '@fontsource/ibm-plex-sans-arabic/600.css'
import '@fontsource/ibm-plex-sans-arabic/700.css'
import './styles/index.css'
import { applyDocumentLanguage, i18n, initI18n } from '@/i18n'
import { useThemeSync } from '@/lib/theme'
import { usePreferences } from '@/store/preferences'
import { router } from './router'

initI18n(usePreferences.getState().language)

const queryClient = new QueryClient()

function App() {
  useThemeSync()
  const language = usePreferences((s) => s.language)

  useEffect(() => {
    if (i18n.language !== language) void i18n.changeLanguage(language)
    applyDocumentLanguage(language)
  }, [language])

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
